<template>
  <span class="text-headline" data-cy="value-item">{{ formattedValue }}</span>
</template>

<script lang="ts" setup>
import { computed } from "vue";

import { formatNumberWithCommas } from "@/helpers/formatting";

const props = defineProps({
  value: {
    type: Number,
    required: true,
  },
});

const formattedValue = computed(() => {
  return formatNumberWithCommas(props.value);
});
</script>
